import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";
import { Link } from "react-router-dom";
import { GS } from "App";

// ################################ INTERFACES & PROPS ################################
type _Base = import("@utils/ClassTypes")._Base;
// MenuComponent => Rename all instances to use
type MenuComponentProps = {
  _sacramentos?: boolean;
  _nichos?: boolean;
} & _Base;

// ################################ RENDERING COMPONENT ################################
const _MenuComponent = (props: MenuComponentProps) => {
  const sacramentos =
    props._sacramentos &&
    GS.parroquia.sacramentos &&
    GS.currentUser?.permiso_sacramentos !== -1;
  const nichos =
    props._nichos && GS.parroquia.nichos && GS.currentUser?.permiso_nichos !== -1;

  return (
    <div className={props.className}>
      {sacramentos && (
        <div className="menu">
          <h1>Sacramentos</h1>
          <div className="wrapper">
            <Link to={"/sacramentos/bautizos"}>Bautizos</Link>
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                width: "100%",
              }}
            >
              <Link to={"/sacramentos/comuniones"}>Comuniones</Link>
              <Link to={"/sacramentos/confirmaciones"}>Confirmaciones</Link>
            </div>
            <Link to={"/sacramentos/matrimonios"}>Matrimonios</Link>
          </div>
        </div>
      )}

      {nichos && (
        <div className="menu">
          <h1>Nichos</h1>
          <div className="wrapper">
            <Link to={"/nichos/beneficiarios"}>Titulares y Beneficiarios</Link>
            <Link to={"/nichos/cenizas"}>Cenizas</Link>
            <Link to={"/nichos/secciones"}>Secciones y cubículos</Link>
          </div>
        </div>
      )}

      {!sacramentos && !nichos && <>Está vacío...</>}
    </div>
  );
};

// ################################ STYLES ################################
const MenuComponent = styled(_MenuComponent).attrs(
  (props: MenuComponentProps): MenuComponentProps => {
    return {
      _sacramentos: true,
      _nichos: true,
      ...props,
    };
  }
)`
  ${(props) => css`
    position: relative;
    background-image: url(https://pbs.twimg.com/media/FGYDtvxXsAEMUqt.jpg);
    background-size: cover;

    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: var(--color-objects-3);
      opacity: 0.35;
    }

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    padding: 1rem 0;

    .menu {
      display: flow-root;
      width: 50%;
      z-index: 1;

      .wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        a {
          width: 7em;
          color: var(--color-secondary-3);
          background-color: var(--color-objects-3);
          border: 2px solid var(--color-secondary-3);
          border-radius: 1em;
          aspect-ratio: 1/1;

          font-family: var(--font-dancing);
          font-size: 2.25rem;

          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;

          &:hover {
            opacity: 0.6;
          }
        }
      }
    }

    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default MenuComponent;
